import actions from '../../actionTypes';

export default (searchText) => {
  return {
    type: actions.FILTER_CATEGORY,
    searchText
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/getFilteredCategories.js